<template>
  <b-container class="scheduling-container">
    <b-row>
      <b-col cols="12" class="title">
        <span>Select when the system action(s) will occur.</span>
      </b-col>
    </b-row>
    <b-row class="scheduling-panel">
      <b-col cols="12" class="pl-28 pr-28">
        <b-form-group>
          <b-form-radio-group v-model="schedulingType" class="radio-btn-titles" name="radios-stacked" stacked>
            <label class="trigger-label"> <input name="some-radios" type="radio" class="radio-box" value="immediately" v-model="schedulingType" />Trigger Immediately </label>
            <label class="trigger-label"> <input name="some-radios" type="radio" class="radio-box" value="noOfDays" v-model="schedulingType" />In Number of Days </label>
            <div class="row pb-25" v-if="schedulingType === 'noOfDays'">
              <div class="col-sm-8 days-input-box">
                <div class="">
                  <input type="number" min="1" class="form-control completion_window_days input-color" placeholder="Enter" v-model="noOfDays" />
                  days <sup class="red-asterisk">*</sup>
                </div>
              </div>
              <div class="col-sm-8 days-input-box" v-if="!hasRemoveAnActivityConfiguredOnly">
                <div class="">
                  <div class="scheduler-heading">
                    What is the completion window?
                    <a class="color_grey cursor_pointer" data-toggle="modal" data-target="#completionModal">
                      <i class="fa fa-info-circle p-1" @click="toggleCompletionModal(true)"></i>
                    </a>
                  </div>
                  <input type="number" min="1" class="form-control completion_window_days input-color" placeholder="Enter" v-model="completionWindow" />
                  days <sup class="red-asterisk">*</sup>
                </div>
              </div>
            </div>
            <label class="trigger-label"> <input name="some-radios" type="radio" class="radio-box" value="milestoneORcustom" v-model="schedulingType" />On Milestone(s) or Custom Frequency </label>
            <div class="pl-24" v-if="schedulingType === 'milestoneORcustom'">
              <div class="pt-10 clearfix survey_qs">
                Which method would you like to schedule with?
                <sup class="red-asterisk">*</sup>
              </div>
              <div class="scheduler_section">
                <div class="scheduler_types">
                  <span
                    class="scheduler_type"
                    :class="{
                      active_item: scheduler.type === 'milestone',
                      'disabled-milestone': !(studyData.milestones && studyData.milestones.length)
                    }"
                    v-on:click="changeType('milestone')"
                  >
                    <span class="type_icon_bg">
                      <i class="fa fa-flag-o" aria-hidden="true"></i>
                    </span>
                    &nbsp; Milestones
                  </span>
                  <span class="scheduler_type" :class="{ active_item: scheduler.type === 'custom' }" v-on:click="changeType('custom')">
                    <span class="type_icon_bg">
                      <i class="fa fa-sliders" aria-hidden="true"></i>
                    </span>
                    &nbsp; Custom frequency
                  </span>
                </div>
                <div class="pt-10" v-if="scheduler.type === 'milestone'">
                  <div v-if="studyData.milestones && studyData.milestones.length > 0">
                    <div class="scheduler-heading pb-5 survey_qs">
                      Which milestones will your participants complete their activity?
                      <!-- <span class="edit_milestone_link" v-on:click="updateMilestones()">Edit milestones</span> -->
                      <sup class="red-asterisk">*</sup>
                    </div>
                    <div v-if="studyData.screeningMilestoneAllowed">
                      <div :class="[scheduler.milestones && scheduler.milestones.indexOf(milestone.milestoneDay) >= 0 ? ['selected_milestone', 'p-0'] : '', getDisabledMilestones(milestone.milestoneDay) ? 'disabled_frequency' : '']" class="milestone_card" :key="index" v-for="(milestone, index) in screeningMilestones">
                        <div class="day_card" v-on:click="selectUnselectMileStone(milestone.milestoneDay)">
                          <p class="m-0">{{ milestone.milestoneName }}</p>
                          <p class="m-0 day_text">
                            Day
                            {{ getDynamicSchedulingServiceData.getDisplayMilestoneDay(milestone.milestoneDay) }}
                          </p>
                          <i v-if="scheduler.milestones && scheduler.milestones.indexOf(milestone.milestoneDay) >= 0" class="fa fa-check-circle" aria-hidden="true"></i>
                        </div>
                        <div class="completion-window  d-flex justify-content-between" v-if="!hasRemoveAnActivityConfiguredOnly && scheduler && scheduler.milestones && scheduler.milestones.indexOf(milestone.milestoneDay) >= 0">
                          <p class="">Completion Window</p>
                          <input type="number" placeholder="1 day" v-model="scheduler.completionWindows[milestone.milestoneDay]" v-on:blur="setCompletionWindows(milestone, scheduler.completionWindows[milestone.milestoneDay])" />
                        </div>
                      </div>
                    </div>
                    <div>
                      <div :class="[scheduler.milestones && scheduler.milestones.indexOf(milestone.milestoneDay) >= 0 ? ['selected_milestone', 'p-0'] : '', getDisabledMilestones(milestone.milestoneDay) ? 'disabled_frequency' : '']" class="milestone_card" :key="index" v-for="(milestone, index) in regularMilestones">
                        <div class="day_card" v-on:click="selectUnselectMileStone(milestone.milestoneDay)">
                          <p class="m-0">Milestone {{ index + 1 }}</p>
                          <p class="m-0 day_text">
                            Day
                            {{ getDynamicSchedulingServiceData.getDisplayMilestoneDay(milestone.milestoneDay) }}
                          </p>
                          <i v-if="scheduler.milestones && scheduler.milestones.indexOf(milestone.milestoneDay) >= 0" class="fa fa-check-circle" aria-hidden="true"></i>
                        </div>
                        <div class="completion-window  d-flex justify-content-between" v-if="!hasRemoveAnActivityConfiguredOnly && scheduler && scheduler.milestones && scheduler.milestones.indexOf(milestone.milestoneDay) >= 0">
                          <p class="">Completion Window</p>
                          <input type="number" placeholder="1 day" v-model="scheduler.completionWindows[milestone.milestoneDay]" v-on:blur="setCompletionWindows(milestone, scheduler.completionWindows[milestone.milestoneDay])" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="pt-10" v-if="scheduler.type === 'custom'">
                <div class="pb-5 scheduler-heading survey_qs">
                  Which frequency will your participants complete their activity?
                  <sup class="red-asterisk">*</sup>
                </div>
                <div
                  :class="{
                    selected_milestone: scheduler.frequency && scheduler.frequency.type && f.type === scheduler.frequency.type,
                    disabled_frequency: f.disabled
                  }"
                  class="milestone_card"
                  :key="index"
                  v-for="(f, index) in frequencies"
                  v-on:click="selectUnselectFrequency(f)"
                >
                  <p class="m-0 pt-5">{{ f.title }}</p>
                  <i v-if="scheduler.frequency && scheduler.frequency.type && f.type === scheduler.frequency.type" class="fa fa-info-circle p-1" aria-hidden="true"></i>
                </div>
                <div id="screen-modal" class="modal fade modal-position" role="dialog">
                  <div class="modal-dialog">
                    <!-- Modal content-->
                    <div class="modal-content">
                      <img src="static/img/repeatable-activity-example.png" />
                    </div>
                  </div>
                </div>
                <div class="row" v-if="!hasRemoveAnActivityConfiguredOnly">
                  <div class="col-sm-4 p-0">
                    <div class="pt-10">
                      <div class="scheduler-heading">
                        What is the completion window?
                        <a class="color_grey cursor_pointer" data-toggle="modal" data-target="#scheduling-configuration-completion-window">
                          <i class="fa fa-info-circle p-1" @click="toggleCompletionModal(true)"></i>
                        </a>
                      </div>
                      <input type="number" min="1" class="form-control completion_window_days input-color" placeholder="Enter" v-model="completionWindow" />
                      days <sup class="red-asterisk">*</sup>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>

    <!-- Completion Window Modal Dialog Start -->
    <div id="scheduling-configuration-completion-window" class="modal modal-position fade" role="dialog" data-backdrop="false">
      <div class="modal-dialog modal-lg modal-dialog-own">
        <div class="modal-content p-0">
          <div class="modal-body p-0">
            <!-- Modal content-->
            <div class="completion_modal-content">
              <div>
                <div class="row text-right">
                  <a class="cancelImage cursor_pointer" data-dismiss="modal">
                    <i class="fa fa-times" aria-hidden="true" @click="toggleCompletionModal(false)"></i>
                  </a>
                </div>
                <div class="example">
                  <p class="example-header">
                    When a task is assigned, you have the opportunity to set the window of completion for the task before it expires.
                  </p>
                  <div class="bg-milestone pb-40">
                    <p class="example-content text-center">
                      Example: A survey is assigned to a participant at study week 2, which for this participant happens to be a Wednesday, and a 3 day completion window has been set. The survey will be pushed to the participant on Wednesday and will be available through Friday. On Saturday morning, the survey will be removed from participant’s task list and will be reported as a missed task.
                    </p>
                    <div class="row milestone">
                      <div class="col-lg-2 ml-0 pl-0 mr-0 pr-0" v-for="(milestone, index) in exampleMileStone" :key="index">
                        <div class="text-center">{{ milestone.day }}</div>
                        <div class="milestone_box" :class="{ 'white-bg': milestone.day === 'Sat' }">
                          <div
                            class="circle"
                            v-if="milestone.class"
                            :class="{
                              'bg-green': milestone.day === 'Wed',
                              'bg-red': milestone.day === 'Sat'
                            }"
                          ></div>
                        </div>
                        <div class="text-center">{{ milestone.date }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-backdrop" @click="toggleCompletionModal(false)"></div>
    </div>
  </b-container>
</template>

<script>
import _ from "lodash";
import toastr from "toastr";
import { mapGetters } from "vuex";
import { TRIGGER_NAME } from "@/constants/dynamicSchedulingConstants";

export default {
  name: "scheduling-configuration-step",
  components: {},
  data() {
    return {
      studyId: null,
      phoneNumberEnable: false,
      surveyId: null,
      studyData: {},
      studyDuration: null,
      taskId: null,
      milestones: [],
      frequencies: [
        { type: "daily", title: "Daily", days: 1, disabled: false },
        { type: "weekly", title: "Weekly", days: 7, disabled: false },
        { type: "biweekly", title: "Every 2 Weeks", days: 14, disabled: false },
        { type: "monthly", title: "Monthly", days: 30, disabled: false },
        {
          type: "biannually",
          title: "Bi-annually",
          days: 182,
          disabled: false
        },
        { type: "annually", title: "Annually", days: 365, disabled: false }
      ],
      scheduler: {
        type: "milestone",
        milestones: [],
        frequency: { type: null, title: null, days: null },
        startDay: null,
        endDay: null,
        completionWindow: null,
        completionWindows: {},
        notificaitons: [],
        allowMultipleTimes: false,
        allowUntillDuration: false,
        showDailySummary: false,
        duration: [{ startDay: null, endDay: null }],
        activitySchedulingMode: "schedule"
      },
      exampleMileStone: [
        { date: "Day1", day: "Wed", class: "bg-green" },
        { date: "Day2", day: "Thur", class: "" },
        { date: "Day3", day: "Fri", class: "" },
        { date: "+2", day: "Sat", class: "bg-red" }
      ],
      schedulingType: "immediately",
      noOfDays: null,
      completionWindow: null,
      scheduling: [],
      selectedMilesOnTriggersPage: [],
      hasRemoveAnActivityConfiguredOnly: true,
      schedulingsEditData: null,
      lastStateOfSchedulingType: null
    };
  },
  props: {
    taskDetails: {
      type: [Object, String],
      default: null
    },
    editSchedulingData: {
      type: Array,
      defaultText: [],
      required: false
    }
  },
  watch: {
    editSchedulingData: {
      deep: true,
      immediate: true,
      handler: function(newData) {
        this.schedulingsEditData = newData;
        if (!newData || (newData && !newData.length)) {
          // When a schedule is added
          this.schedulingType = "immediately";
          this.resetSchedulingValues(null);
        } else {
          // When a schedule is edited
          this.bindEditData(newData);
        }
      }
    },
    getConfiguredTriggersData: {
      deep: true,
      immediate: true,
      handler: function(newData) {
        if (newData && newData.length) {
          const triggers = newData;

          /* Disable milestones which have study day smaller than max. one chosen on 1 of 3 page - START */

          this.selectedMilesOnTriggersPage = [];
          triggers.forEach(t => {
            if (t.trigger === TRIGGER_NAME.MILESTONE_COMPLETED) {
              this.selectedMilesOnTriggersPage = t.milestones.map(mile => mile.milestoneDay);
            }
          });
          this.removeDisabledMilestones();

          /* Disable milestones which have study day smaller than max. one chosen on 1 of 3 page. - END */
        }
      }
    },
    getConfiguredActionsData: {
      deep: true,
      immediate: true,
      handler: function(newData) {
        if (newData && newData.length) {
          const actions = newData;
          this.hasRemoveAnActivityConfiguredOnly = true;
          actions.forEach(a => {
            if (a.type === "addActivity") {
              this.hasRemoveAnActivityConfiguredOnly = false;
            }
          });

          if (this.hasRemoveAnActivityConfiguredOnly) {
            this.completionWindow = null;
          }
        }
      }
    },
    schedulingType: {
      deep: true,
      immediate: true,
      handler: function(newData) {
        if (newData && newData.length) {
          /* Don't reset values during editing and radio button is not changed, but can reset when radio button is changed/switched while ADD && EDIT */

          if (!(this.schedulingsEditData && this.schedulingsEditData.length && this.lastStateOfSchedulingType === newData)) {
            this.resetSchedulingValues(null);
          }
          this.lastStateOfSchedulingType = newData;
        }
      }
    }
  },
  computed: {
    ...mapGetters(["getConfiguredTriggersData", "getConfiguredActionsData", "getDynamicSchedulingServiceData"]),
    regularMilestones() {
      if (this.studyData.milestonesList) {
        if (this.studyData.screeningMilestoneAllowed && this.studyData.screeningDuration) {
          const filtered = this.studyData.milestonesList.filter(mile => mile.milestoneType != "screening");
          return filtered;
        } else {
          return this.studyData.milestonesList;
        }
      }
      return [];
    },
    screeningMilestones() {
      if (this.studyData.milestonesList) {
        const filtered = this.studyData.milestonesList.filter(mile => mile.milestoneType == "screening");
        return filtered;
      }
      return [];
    }
  },
  mounted() {
    this.studyId = this.$route.params.studyId;
    this.getStudyDetails();
  },
  methods: {
    bindEditData(schedulings) {
      const data = schedulings && schedulings[0];
      if (!data) {
        return;
      }

      this.schedulingType = data.type === "custom" || data.type === "milestone" ? "milestoneORcustom" : data.type;
      if (data.type === "noOfDays") {
        this.noOfDays = data.days;
        this.completionWindow = data.completionWindow;
      } else if (data.type === "milestone") {
        this.completionWindow = data.completionDuration;
        this.completionDuration = data.completionDuration;
        this.scheduler = {
          ...this.scheduler,
          type: data.type,
          milestones: data.milestones,
          allowMultipleTimes: false,
          allowUntillDuration: false,
          activitySchedulingMode: "schedule",
          completionWindows: data.completionWindows
        };
      } else if (data.type === "custom") {
        this.completionWindow = data.completionDuration;
        this.completionDuration = data.completionDuration;
        this.scheduler = {
          ...this.scheduler,
          type: data.type,
          frequency: data.frequency,
          allowUntillDuration: false
        };
      }
      this.lastStateOfSchedulingType = data.type === "custom" || data.type === "milestone" ? "milestoneORcustom" : data.type;
    },
    changeType(type) {
      if (type === this.scheduler.type) {
        /* To avoid resetting of value when already selected 'milestone' or 'custom' r selected again */
        return;
      }
      this.scheduler.type = type;
      this.resetSchedulingValues(type);
    },
    resetSchedulingValues(milestoneOrcustom) {
      if (this.schedulingType === "immediately") {
        this.noOfDays = null;
        this.resetAllCompletionWindows();
        this.scheduler.type = "milestone";
        this.scheduler.milestones = [];
        this.scheduler.frequency = { type: null, title: null, days: null };
      } else if (this.schedulingType === "noOfDays") {
        this.noOfDays = null;
        this.resetAllCompletionWindows();
      } else if (this.schedulingType === "milestoneORcustom") {
        this.resetAllCompletionWindows();

        if (milestoneOrcustom === null) {
          this.scheduler.type = "milestone";
        }

        if (!(this.studyData.milestones && this.studyData.milestones.length)) {
          /* If there are No Milestones */
          this.scheduler.type = "custom";
        }

        if (this.scheduler.type === "milestone") {
          this.scheduler.milestones = [];
        } else {
          this.scheduler.frequency = { type: null, title: null, days: null };
        }
      }
    },
    resetAllCompletionWindows() {
      this.completionWindow = null;
      this.scheduler.completionWindows = {};
    },
    selectUnselectMileStone(milestone) {
      this.scheduler.frequency = { type: null, title: null, days: null };
      if (!this.scheduler.milestones) {
        this.scheduler.milestones = [];
      }

      if (!this.scheduler.completionWindows) {
        this.scheduler.completionWindows = {};
      }

      if (this.scheduler && this.scheduler.milestones && this.scheduler.milestones.indexOf(milestone) < 0) {
        this.scheduler.milestones.push(milestone);
      } else {
        this.scheduler.milestones.splice(this.scheduler.milestones.indexOf(milestone), 1);
        delete this.scheduler.completionWindows[milestone];
      }

      this.$forceUpdate();
    },
    selectUnselectFrequency(frequency) {
      this.scheduler.milestones = [];
      this.scheduler.frequency = frequency;
      this.$forceUpdate();
    },
    getDisabledMilestones(milestoneStudyDay) {
      let isMileDisabled = false;
      const maxMileStudyDay = _.max(this.selectedMilesOnTriggersPage);
      if (maxMileStudyDay > milestoneStudyDay) {
        isMileDisabled = true;
      }
      return isMileDisabled;
    },
    removeDisabledMilestones() {
      const maxMileStudyDay = _.max(this.selectedMilesOnTriggersPage);
      if (maxMileStudyDay && this.scheduler && this.scheduler.milestones && this.scheduler.milestones.length) {
        this.scheduler.milestones = this.scheduler.milestones.filter(m => m >= maxMileStudyDay);
      }
    },
    toggleCompletionModal(showModal) {
      if (showModal) {
        window.$("#scheduling-configuration-completion-window").modal("show");
      } else {
        window.$("#scheduling-configuration-completion-window").modal("hide");
      }
    },
    getStudyDetails() {
      this.$api.getStudyDataFact(this.studyId).then(
        response => {
          this.studyData = response.body;
          const sd = new Date(this.studyData.firstPatientEnrollDate).valueOf();
          const ed = new Date(this.studyData.firstPatientLastDate).valueOf();

          if (!(this.studyData.milestones && this.studyData.milestones.length)) {
            /* If there are No Milestones */
            this.scheduler.type = "custom";
          }

          this.studyDuration = parseInt((this.getExactDayEpoch(ed) - this.getExactDayEpoch(sd)) / 1000 / 86400, 10);
          _.forEach(this.frequencies, val => {
            switch (val.type) {
              case "daily":
                val.disabled = this.studyDuration < 1;
                break;
              case "weekly":
                val.disabled = this.studyDuration < 7;
                break;
              case "biweekly":
                val.disabled = this.studyDuration < 15;
                break;
              case "monthly":
                val.disabled = this.studyDuration < 30;
                break;
              case "biannually":
                val.disabled = this.studyDuration < 180;
                break;
              case "annually":
                val.disabled = this.studyDuration < 365;
                break;
              default:
                break;
            }
          });
        },
        error => {
          toastr.error(error.body ? error.body.message : "Error while getting the study details.");
        }
      );
    },
    getExactDayEpoch(day) {
      const newDay = new Date(day);
      return new Date(newDay.getFullYear(), newDay.getMonth(), newDay.getDate(), 0, 0, 0).getTime();
    },
    getStudyStartDayAndEndDay(studyData) {
      const sd = studyData.studyStartDate;
      const ed = studyData.studyEndDate;
      const studyDuration = parseInt((this.getExactDayEpoch(ed) - this.getExactDayEpoch(sd)) / 1000 / 86400, 10);
      return [{ startDay: 1, endDay: studyDuration }];
    },
    setCompletionWindows(milestone, completionWindow) {
      milestone.completionWindow = Number(completionWindow);
    },
    saveSchedule() {
      /*Instruction- If you are modifing any thing on this method so pls change same on method "cloneMethodOfSaveSchedule"*/
      let scheduleObj = null;

      if (this.schedulingType === "immediately") {
        scheduleObj = {
          type: this.schedulingType
        };
      } else if (this.schedulingType === "noOfDays") {
        scheduleObj = {
          type: this.schedulingType,
          days: this.noOfDays,
          completionWindow: this.completionWindow
        };
      } else {
        scheduleObj = {
          type: this.scheduler.type,
          startDate: null,
          endDate: null,
          delay: null,
          milestones: null,
          completionDuration: null,
          completionWindow: null,
          completionWindows: {},
          allowMultiReponseInCompletionWindow: null,
          showDailySummary: null,
          allowUntillDuration: null,
          frequency: null,
          duration: null,
          startDay: null,
          endDay: null,
          advanceScheduleDays: null,
          sequence: null,
          displayOrder: null,
          delayType: null,
          milestonesList: []
        };
        if (this.scheduler.type === "custom") {
          scheduleObj.frequency = this.scheduler.frequency;
          scheduleObj.completionDuration = this.completionWindow;
          scheduleObj.completionWindow = this.completionWindow;
          scheduleObj.allowUntillDuration = false;
          scheduleObj.duration = this.getStudyStartDayAndEndDay(this.studyData);
        } else {
          scheduleObj.completionDuration = this.completionWindow;
          scheduleObj.completionWindow = this.completionWindow;
          scheduleObj.completionWindows = this.scheduler.completionWindows;

          this.scheduler.milestones = this.scheduler.milestones;
          scheduleObj.milestones = [...this.scheduler.milestones];

          for (const i in this.studyData.milestonesList) {
            const mile = this.studyData.milestonesList[i];
            for (const j in this.scheduler.milestones) {
              if (mile.milestoneDay === this.scheduler.milestones[j]) {
                scheduleObj.milestonesList.push(mile);
                break;
              }
            }
          }
        }
      }

      this.scheduling = [];
      this.scheduling.push(scheduleObj);
    },
    checkValidation(originalScheduler) {
      const scheduler = { ...originalScheduler };
      let validScheduler = true;

      this.completionWindow = this.hasRemoveAnActivityConfiguredOnly ? 1 : this.completionWindow;
      scheduler["completionWindow"] = this.completionWindow ? Number(this.completionWindow) : null;
      scheduler["noOfDays"] = this.noOfDays ? Number(this.noOfDays) : null;

      if (this.schedulingType === "immediately") {
        this.saveSchedule();
      } else if (this.schedulingType === "noOfDays") {
        if (!scheduler.noOfDays || scheduler.noOfDays <= 0 || scheduler.noOfDays % 1 !== 0) {
          validScheduler = false;
          toastr.error(scheduler.noOfDays === null ? "In number of days is required." : "Please specify number of days with value greater than 0 and cannot have decimals.");
        } else if (this.studyDuration <= scheduler.noOfDays) {
          validScheduler = false;
          toastr.error("Specified number of days cannot exceed study duration.");
        } else if (!scheduler.completionWindow || scheduler.completionWindow <= 0 || scheduler.completionWindow % 1 !== 0) {
          validScheduler = false;
          toastr.error(scheduler.completionWindow === null ? "Please specify completion window." : "Please specify completion window with value greater than 0 and cannot have decimals.");
        } else if (this.studyDuration <= scheduler.completionWindow) {
          validScheduler = false;
          toastr.error("Specified completion window cannot exceed study duration.");
        }

        this.saveSchedule();
      } else {
        switch (scheduler.type) {
          case "milestone":
            if (!scheduler.milestones || scheduler.milestones.length <= 0) {
              validScheduler = false;
              toastr.error("Please select a milestone.");
            }

            if (this.studyData.milestonesList && this.studyData.screeningMilestoneAllowed) {
              const list = this.studyData.milestonesList.filter(mile => mile.milestoneType == "screening");
              const duration = this.studyData.screeningDuration;
              if (!this.validateMilestones(list, duration, "screening")) {
                return;
              }
            }

            const list = this.studyData.milestonesList.filter(mile => mile.milestoneType != "screening");
            const duration = this.studyData.studyDuration;
            if (!this.validateMilestones(list, duration, "")) {
              return;
            }

            if (validScheduler) {
              this.saveSchedule();
            }
            break;
          case "custom":
            scheduler.frequency = scheduler.frequency ? scheduler.frequency : { type: null, title: null, days: null };

            if (scheduler.taskType !== "notification" && (!scheduler.frequency.type || !scheduler.completionWindow)) {
              validScheduler = false;
              toastr.error(!scheduler.frequency.type ? "Please select a frequency." : "Please specify completion window.");
            } else if (scheduler.taskType !== "notification" && (scheduler.completionWindow <= 0 || scheduler.completionWindow % 1 !== 0)) {
              validScheduler = false;
              toastr.error("Completion window should be greater than 0 and cannot have decimals.");
            } else if (scheduler.taskType !== "notification" && scheduler.completionWindow > scheduler.frequency.days) {
              validScheduler = false;
              toastr.error("Completion window cannot exceed the length of the frequency.");
            } else {
              this.saveSchedule();
            }
            break;
          default:
            break;
        }
      }
      return validScheduler;
    },
    validateMilestones(list, duration, type) {
      const milestoneList = list;
      let filteredScheduler;

      // This set completion windows == 1, for every selected milestones when remove an activity is configured only.
      if (this.hasRemoveAnActivityConfiguredOnly) {
        this.scheduler.milestones.forEach(milestoneDay => {
          this.scheduler.completionWindows[milestoneDay] = 1;
        });
      }

      const filteredCompletionWindow = _.cloneDeep(this.scheduler.completionWindows);

      filteredScheduler = this.scheduler.milestones.filter(m => m >= 0);
      Object.keys(filteredCompletionWindow).forEach(key => {
        if (key < 0) {
          delete filteredCompletionWindow[key];
        }
      });

      filteredScheduler.sort((a, b) => a - b);
      for (let i = 0; i < milestoneList.length; i++) {
        const milestoneDay = milestoneList[i].milestoneDay;
        let completionWindow = filteredCompletionWindow[milestoneDay];
        const selectedMilestoneIndex = filteredScheduler.indexOf(milestoneDay);

        const nextSelectedMilestoneDay = filteredScheduler[selectedMilestoneIndex + 1];
        completionWindow = Number(completionWindow);

        if (filteredScheduler.indexOf(milestoneDay) < 0) {
          continue;
        }

        if (!completionWindow) {
          toastr.error("Number of days for completion window is required.");
          return false;
        } else if (completionWindow < 1) {
          toastr.error("Please specify completion window with value greater than 0.");
          return false;
        } else if (completionWindow % 1 > 0) {
          toastr.error("Please specify completion window with value greater than 0 and cannot have decimals.");
          return false;
        } else if (completionWindow > duration) {
          if (type == "screening") {
            toastr.error(`Specified completion window cannot exceed ${type} duration.`);
          } else {
            toastr.error("Specified completion window cannot exceed study duration.");
          }
          return false;
        } else if (nextSelectedMilestoneDay && milestoneDay + completionWindow > nextSelectedMilestoneDay) {
          toastr.error(`Specified completion window overlaps with another ${type} milestone.`);
          return false;
        }
      }
      return true;
    },
    cloneMethodOfSaveSchedule() {
      /*Whatever changes you made on savechanges method do same here*/
      let scheduleObj = null;

      if (this.schedulingType === "immediately") {
        scheduleObj = {
          type: this.schedulingType
        };
      } else if (this.schedulingType === "noOfDays") {
        scheduleObj = {
          type: this.schedulingType,
          days: this.noOfDays,
          completionWindow: this.completionWindow
        };
      } else {
        scheduleObj = {
          type: this.scheduler.type,
          startDate: null,
          endDate: null,
          delay: null,
          milestones: null,
          completionDuration: null,
          completionWindow: null,
          allowMultiReponseInCompletionWindow: null,
          showDailySummary: null,
          allowUntillDuration: null,
          frequency: null,
          duration: null,
          startDay: null,
          endDay: null,
          advanceScheduleDays: null,
          sequence: null,
          displayOrder: null,
          delayType: null,
          milestonesList: []
        };
        if (this.scheduler.type === "custom") {
          scheduleObj.frequency = this.scheduler.frequency;
          scheduleObj.completionDuration = this.completionWindow;
          scheduleObj.completionWindow = this.completionWindow;
          scheduleObj.allowUntillDuration = false;
          scheduleObj.duration = this.getStudyStartDayAndEndDay(this.studyData);
        } else {
          scheduleObj.completionDuration = this.completionWindow;
          scheduleObj.completionWindow = this.completionWindow;

          scheduleObj.milestones = [...this.scheduler.milestones];

          for (const i in this.studyData.milestonesList) {
            const mile = this.studyData.milestonesList[i];
            for (const j in this.scheduler.milestones) {
              if (mile.milestoneDay === this.scheduler.milestones[j]) {
                scheduleObj.milestonesList.push(mile);
                break;
              }
            }
          }
        }
      }
      return scheduleObj;
    }
  }
};
</script>
<style lang="scss">
.scheduling-container {
  .trigger-label {
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
    display: flex;
    align-items: center;

    .radio-box {
      width: 16px;
      height: 16px;
      margin-right: 5px;
    }
  }
  .red-asterisk {
    color: #f16559;
    font-size: 14px;
    font-weight: bold;
    top: -0.2em;
  }
  select,
  .select-custom {
    background-position: right 50% !important;
    background-repeat: no-repeat;
    background-image: url(/static/img/arrow-down.png);
    position: relative !important;
    border-radius: 4px;
    &::after {
      transform: rotate(90deg);
    }
    .dropdown.icon {
      right: -3px !important;
      top: 5px !important;
      &:before {
        content: url(/static/img/arrow-down.png);
      }
    }
  }
  & .options-cls {
    position: absolute !important;
    top: 0 !important;
  }

  .scheduling-panel {
    padding: 0 0 160px;
    max-height: 450px;
    overflow-y: auto;
    overflow-x: hidden;
  }

  padding: 21px 0 50px;
  max-height: 507px;
  & .title {
    span {
      font-family: RobotoRegular;
      font-size: 16px;
      color: #000;
    }
    padding-left: 28px;
    margin-bottom: 11px;
  }
  & .radio-btn-titles {
    font-family: RobotoRegular;
    color: #4a4a4a;

    .custom-radio {
      line-height: 25px;
    }
    .custom-radio .custom-control-input:checked ~ .custom-control-label::before {
      background-color: #fff;
      border: 1px solid #4c8ce4;
    }
    .custom-radio .custom-control-input:checked ~ .custom-control-label::after {
      background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='4' fill='%234c8ce4'/%3E%3C/svg%3E");
    }
    .custom-control-label::before {
      top: 5px;
      width: 16px;
      height: 16px;
    }
    .custom-control-label::after {
      background-size: 0.68rem 0.68rem;
      top: 5px;
      width: 16px;
      height: 16px;
    }
  }
  & .m-top-15 {
    margin-top: 15px;
  }
  /* & .gray-bg { */

  & .gray-icon {
    padding: 13%;
    background-color: #dfe8ec;
    color: #acb5b9;
    font-size: 20px;
    font-weight: 500;
    border-radius: 3px;
  }
  /* } */
  & .divider-line {
    margin-top: 3%;
    margin-bottom: 3%;
    background-color: #c5d1d6;
    height: 1px;
    width: 100%;
  }
  & .dynamic-activity-scheduler-btn {
    border-radius: 4px;
    border: solid 1px #4c8ce4;
    background: #fff;
    font-family: "RobotoRegular";
    font-size: 15px;
    color: #4c8ce4;
    padding: 3px 12px 4px 12px;
    position: relative;
    &:hover {
      cursor: pointer;
      color: #649be8;
      border: solid 1px #649be8;
      box-shadow: 0 1px 0px 0 rgba(230, 230, 230, 2%), 0 1px 9px 0 rgba(230, 230, 230, 19%);
    }
    &:active {
      cursor: pointer;
      color: #4c8ce4;
      border: solid 1px #4c8ce4;
      box-shadow: none;
    }
  }
  .custom-message-textarea {
    margin-bottom: 15px;
  }
  .message-box {
    padding: 10px;
    border-radius: 3px;
    border: solid 1px #d3dfe4;
    color: #666669;
    font-size: 14px;
  }
  .message-save-btn {
    position: absolute;
    right: 25px;
    bottom: 25px;
    padding: 5px 10px;
    border-radius: 4px;
    background-color: #4c8ce4;
    color: #fff;
    border: none;
    cursor: pointer;
  }
  .days-input-box {
    padding: 2px 25px 20px;
  }
  .scheduler-heading {
    font-weight: 500;
    padding-bottom: 8px;
  }
  .scheduler-heading-large {
    font-size: 16px;
  }

  .survey_qs {
    font-weight: 600;
    color: #666769;
    font-size: 16px;
  }

  /* Completion modal style */
  #scheduling-configuration-completion-window {
    .modal-dialog {
      width: 1000px;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 99999999 !important;
      position: fixed;
    }
    .cancelImage {
      color: #959fa4;
      position: absolute;
      right: 10px;
      top: 7px;
      font-size: 24px;
    }
    .example {
      margin: 40px 40px 20px 40px;
    }
    .example-content {
      padding: 20px 40px 20px 40px;
    }
    .bg-milestone {
      background-color: #f5f8fa;
    }
    .example-header {
      padding: 20px 80px 10px 80px;
      font-weight: bold;
    }
    .milestone {
      justify-content: center;
    }
    .milestone_box {
      border: 1px solid #34537d;
      width: 60px;
      height: 10px;
      padding-top: 1px;
      padding-bottom: 9px;
      border-radius: 100px;
      background-color: #34537d;
    }
    .circle {
      width: 7px;
      height: 8px;
      background-color: white;
      border-radius: 100px;
      margin-left: 3px;
    }
    .bg-green {
      background-color: #2ecc71 !important;
    }

    .bg-red {
      background-color: #ff7171 !important;
    }
  }
  .modal-backdrop {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 100 !important;
    background-color: #000000;
    opacity: 0.5;
  }
  @media (min-width: 576px) {
    #scheduling-configuration-completion-window .modal-dialog {
      margin: 13% auto;
    }
  }
  .input-color {
    background-color: #fff;
    border: 1px solid #cccccc;
    border-radius: 3px;
  }
  .completion_window_days {
    width: 120px;
    margin-right: 5px;
    display: inline-block;
  }
  .completion-window {
    background-color: #c5d1d6;
    display: flex;
    padding: 0 4px;
    border-radius: 3px;
    padding: 8px 4px 4px 11px;
    margin-top: -4px;
  }
  .completion-window > p {
    padding-top: 8px;
    margin: 0;
    font-size: 12px;
    font-family: Roboto;
    line-height: 1.33;
    text-align: left;
    color: #34537d;
  }
  .completion-window > input {
    border: none;
    width: 50px;
    height: 32px;
    border-radius: 2px;
    text-align: center;
    background-color: #ffffff;
    color: #666669;
    padding: 5px;
  }
  .milestone-custom {
    padding-left: 24px;
  }
  .milestone_card {
    vertical-align: top;
    cursor: pointer;
    min-width: 180px;
    border: solid 1px #d3dfe4;
    background-color: #fff;
    border-radius: 2px;
    display: inline-block;
    padding: 8px 10px;
    margin: 1px 8px 8px 1px;
    min-height: 52px;
    color: #c5d1d6;
  }
  .selected_milestone {
    background-color: #32557a;
    border-radius: 4px;
    min-height: 52px;
    color: #fff;
    position: relative;
    .fa {
      position: absolute;
      right: 10px;
      top: 8px;
      font-size: 32px;
      color: #488ee1;
    }
    .day_text {
      color: #ddd;
      font-size: 12px;
    }
    .day_card {
      padding: 10px 8px;
      min-width: 180px;
    }
  }
  .scheduler_types {
    margin-top: 8px;
    .scheduler_type {
      cursor: pointer;
      border: 1px solid #ccc;
      padding: 10px;
      border-radius: 2px;
      min-height: 52px;
      display: inline-block;
      background-color: #fff;
    }
    .scheduler_type {
      margin: 0 10px 10px 0;
    }
    .type_icon_bg {
      background-color: #ddd;
      width: 28px;
      height: 28px;
      display: inline-block;
      border-radius: 100%;
      padding: 3px;
      text-align: center;
    }
    .active_item {
      border: 1px solid #32557a;
      background-color: #32557a;
      color: #fff;
      .type_icon_bg {
        background-color: #488ee1;
      }
    }
  }
}

.disabled_frequency {
  pointer-events: none;
  background-color: #e6e6e6 !important;
}

.disabled-milestone {
  pointer-events: none;
  color: #fff;
  background-color: #e6e6e6 !important;
  border-color: #e6e6e6 !important;
}

.scheduling-panel::-webkit-scrollbar-thumb {
  background-color: #c4c4c4;
  border-radius: 4px;
  height: 50px;
  border: 3px solid transparent;
}

.scheduling-panel::-webkit-scrollbar-track {
  background: transparent;
}

.scheduling-panel::-webkit-scrollbar {
  width: 6px;
}
</style>
